var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"section",attrs:{"id":_vm.content.uid}},[_c('transition',{attrs:{"name":"fade"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showInfo),expression:"!showInfo"}],ref:"logo",class:{ active: _vm.active, 'bottom-logo': _vm.bottomLogo },style:({ color: _vm.content.color })},[_vm._v("\n      "+_vm._s(_vm.content.title)+"\n    ")])]),_vm._l((_vm.content.images),function(image,index){return _c('img',{key:index,staticClass:"lazyload",class:image.orientation,attrs:{"src":image.small,"data-sizes":"auto","data-srcset":image.small +
        ' 750w, ' +
        image.medium +
        ' 1280w, ' +
        image.large +
        ' 1920w, ' +
        image.hq +
        ' 2400w'}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }